import type { CallTransferToolSettings } from "@repo/app-types/entities/tools/callTransfer";
import {
  isNotNullNotUndefined,
  safeParseJSON,
} from "@repo/app-types/helpers/utilities";
import {
  CallTransferToolForm,
  type CallTransferToolFormSettings,
} from "../components/callTransferToolForm.js";
import type { ToolFormConfig } from "./baseFormConfig.js";

export const callTransferToolFormConfig: ToolFormConfig<
  CallTransferToolSettings,
  CallTransferToolFormSettings
> = {
  initialize: (settings) => ({
    destination: settings?.destination ?? "",
    timeoutSeconds: settings?.timeout_seconds?.toString() ?? "",
    timeoutSecondsError: undefined,
    sipHeaders: settings?.sip_headers
      ? JSON.stringify(settings.sip_headers, null, 2)
      : "",
    sipHeadersError: undefined,
  }),
  validate: (settings) => settings.destination.trim() !== "",
  save: (settings) => {
    // Make sure SIP headers are valid JSON
    const parsedSipHeaders: Record<string, string> | undefined | null =
      settings.sipHeaders.trim() !== ""
        ? safeParseJSON(settings.sipHeaders)
        : undefined;

    if (parsedSipHeaders === null) {
      return {
        isValid: false,
        formSettings: {
          sipHeadersError: "SIP Headers must be valid JSON format.",
        },
      };
    }

    // Make sure timeout seconds is a valid number
    const timeoutSecondsValue =
      settings.timeoutSeconds.trim() !== ""
        ? Number(settings.timeoutSeconds.trim())
        : undefined;

    if (
      isNotNullNotUndefined(timeoutSecondsValue) &&
      isNaN(timeoutSecondsValue)
    ) {
      return {
        isValid: false,
        formSettings: {
          timeoutSecondsError: "Timeout must be a valid number",
        },
      };
    }

    return {
      isValid: true,
      settings: {
        destination: settings.destination.trim(),
        timeout_seconds: timeoutSecondsValue,
        sip_headers: parsedSipHeaders,
      },
    };
  },
  Form: CallTransferToolForm,
};
